export const categoryObj: { [x: string | number]: string } = {
  1: '팝',
  2: '락',
  3: 'R&B',
  4: '재즈',
  5: '밴드',
  6: '댄스',
  // 7: '힙합',
};

export const categoryIdObj: { [x: string]: number } = {
  팝: 1,
  락: 2,
  'R&B': 3,
  재즈: 4,
  밴드: 5,
  댄스: 6,
  // 힙합: 7,
};
